import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import Logo from '../assets/images/Siddhant.jpg'

const Footer = () => (
  <Box mt="80px" bgcolor="#FFF3F4">

    <Typography variant="h5" sx={{ fontSize: { lg: '28px', xs: '20px' } }} mt="41px" textAlign="center" pb="40px"><a  href="https://www.linkedin.com/in/siddhant-sharma-86b853190/" style={{textDecoration: 'none' , color: 'black'}}>    <Stack gap="40px" sx={{ alignItems: 'center' }} flexWrap="wrap" px="40px" pt="24px">
      <img src={Logo} alt="logo" style={{ width: '90px', height: '90px' , borderRadius:'50%' , marginBottom:'10px'}} />
  
    </Stack>Made with ❤️ by Siddhant Sharma
</a></Typography>
  </Box>
);

export default Footer;
